define('viewModels/privileged/composer/forms/formEditor/VisibilityConditionPicker',[
    'lib/knockout',
    'lib/lodash4',
    'viewModels/ViewModel',
    'enums/composer/visibilityConditionOperation',
    'viewModels/privileged/composer/forms/formEditor/Predicate'
], function (
    ko,
    _,
    ViewModel,
    visibilityConditionOperation,
    PredicateViewModel
) {
    "use strict";

    var VisibilityConditionPickerViewModel = ViewModel.extend(function (visibilityConditionModel, formEditorState, getQuestionOptions, questionMap, questionGroupIndex) {
        var self = this;

        self.predicates = visibilityConditionModel().predicates;

        var updatePredicatePath = function (predicateView) {
            var newPredicatePath = predicateView.predicatePath();
            var predicateIndex = self.predicateViews().indexOf(predicateView);
            if (predicateIndex !== -1) {
                var unwrappedPredicatesList = self.predicates();
                var oldPredicatePath = unwrappedPredicatesList[predicateIndex];
                if (oldPredicatePath !== newPredicatePath) {
                    unwrappedPredicatesList[predicateIndex] = newPredicatePath;
                    self.predicates(unwrappedPredicatesList);
                    formEditorState.isModified(true);
                }
            }
        };

        self.predicateViews = ko.observableArray();

        var addPredicateView = function(newPredicate) {
            var newView = self.subView(PredicateViewModel,
                newPredicate,
                self.predicates,
                updatePredicatePath,
                questionMap,
                questionGroupIndex,
                getQuestionOptions);
            self.predicateViews.push(newView);
            updatePredicatePath(newView);
        };

        _.each(self.predicates(), function (predicate) {
            addPredicateView(predicate);
        });

        self.combiningOperationOptions = [
            {
                id: visibilityConditionOperation.AND,
                displayName: ko.i18n.renderString("composer.evaluations.editor.visibilityCondition.and")
            },
            {
                id: visibilityConditionOperation.OR,
                displayName: ko.i18n.renderString("composer.evaluations.editor.visibilityCondition.or")
            }
        ];

        var combiningOperation = self.combiningOperationOptions[0];
        if (visibilityConditionModel().combiningOperation() === visibilityConditionOperation.OR) {
            combiningOperation = self.combiningOperationOptions[1];
        }

        self.selectedCombiningOperation = ko.observable(combiningOperation);

        self.canRemovePredicate = function () {
            return self.predicates().length > 1;
        };

        var suggestNextPredicate = function () {
            var nextPredicate = null;
            var questionOptions = getQuestionOptions();
            // Pick last-most elgible question and first-most answer within that question
            for(var i= questionOptions.length - 1; i >= 0 && !nextPredicate; i--) {
                var answerOptions = questionOptions[i].answerOptions();
                for (var j=0; j < answerOptions.length && !nextPredicate; j++) {
                    var predicatePath = PredicateViewModel.buildPredicatePath(questionOptions[i],answerOptions[j]);
                    if (!_.includes(self.predicates(), predicatePath)) {
                        nextPredicate = predicatePath;
                    }
                }
            }
            return nextPredicate;
        };

        self.canAddPredicate = self.computed(function () {
            return !!suggestNextPredicate();
        });

        self.addPredicate = function() {
            if (self.canAddPredicate()) {
                var newPredicate = suggestNextPredicate();
                visibilityConditionModel().addPredicate(newPredicate);
                addPredicateView(newPredicate);
                formEditorState.isModified(true);
            }
        };

        self.removePredicate = function(predicateView) {
            if (self.canRemovePredicate()) {
                self.predicateViews.remove(predicateView);
                visibilityConditionModel().removePredicate(predicateView.predicatePath());
                formEditorState.isModified(true);
            }
        };

        self.subscribe(self.selectedCombiningOperation, function(newValue) {
            //We don't need to recompute potential cycles if only combiningOperation has changed
            visibilityConditionModel().combiningOperation(newValue.id);
            formEditorState.isModified(true);
        });
    });

    return VisibilityConditionPickerViewModel;
});

